<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            Cancel Subscription: Final Step
        </template>

        <template #content>
            <div class="">
                We're sad to see you go &#128546; Why are you cancelling today?
            </div>
            <div class="mb-4 mt-4">
                <ul class="ml-6">
                    <checkbox-list-item v-model="reasons.too_expensive" label="It's too expensive" />
                    <checkbox-list-item v-model="reasons.need_more_features" label="I need more features" />
                    <checkbox-list-item v-model="reasons.found_alternative" label="I found an alternative" />
                    <checkbox-list-item v-model="reasons.no_longer_need" label="I no longer need it" />
                    <checkbox-list-item v-model="reasons.customer_service_issues" label="Customer service was less than expected" />
                    <checkbox-list-item v-model="reasons.ease_of_use_issues" label="Ease of use was less than expected" />
                    <checkbox-list-item v-model="reasons.quality_issues" label="Quality was less than expected" />
                    <checkbox-list-item v-model="reasons.other" label="Other" />

                    <li v-if="reasons.other">
                        <jet-input class="mt-1 block w-full"
                            v-model="reasons.other_reason"
                            placeholder="Other reason"
                        /> 
                    </li>
                </ul>
            </div>
            <div>
                <div class="text-16px"><span class='font-bold'>Don't cancel and get a discount.</span> Contact support for a discount on your subscription.</div>
            </div>
        </template>

        <template #footer>


            <jet-button secondary class="mr-2 w-64 text-center mb-2 sm:mb-0" @click.native="openIntercom">
                CONTACT SUPPORT
            </jet-button>
            

            <jet-button danger :loading="loading" class="w-64 text-center" :disabled="!goodToGo" @click.native="cancel">
                CONFIRM CANCELLATION
            </jet-button>
        </template>
    </jet-dialog-modal>

</template>


<script>
import checkboxListItem from '@/components/checkboxListItem.vue';
export default {
    name: 'CancelAccountConfirmModal',
    emits: ['close', 'cancel'],
    components: {
        checkboxListItem
    },
    data: () => ({
        loading: false,
        reasons: {
            too_expensive: false,
            need_more_features: false,
            found_alternative: false,
            no_longer_need: false,
            customer_service_issues: false,
            ease_of_use_issues: false,
            quality_issues: false,
            other: false,
            other_reason: '',
        }
    }),
    methods: {
        openIntercom() {
            window.Intercom('showNewMessage');
            this.$emit('close');
        },
        cancel() {
            this.loading = true;
            this.$emit('cancel', this.reasons);
        }
    },
    computed: {
        goodToGo() {
            if (this.reasons.other && !this.reasons.other_reason) {
                return false;
            }

            return Object.values(this.reasons).some(reason => reason);
        }
    }

}
</script>